import { Component, ViewChild, ElementRef,HostListener } from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';
import { WebParameterContext } from '../../../../model/common';
import{ NavController,IonInfiniteScroll, ActionSheetController,AlertController,Events,IonTabs,MenuController,ModalController,Platform,PopoverController} from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { BarcodeScanner } from '@ionic-native/barcode-scanner/ngx';
import { NativeService } from 'src/service/native.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { BaseCase } from '../../../basecase';
import { BaseModal } from '../../../../model/base';
import { PlatformLocation} from '@angular/common';
import { typeWithParameters } from '@angular/compiler/src/render3/util';

declare var app;
@Component({
  selector: 'app-a2-daily-bill-inquiry',
  templateUrl: './a2-daily-bill-inquiry.component.html',
  styleUrls: ['./a2-daily-bill-inquiry.component.scss']
})
export class A2DailyBillInquiryComponent extends GridBaseCase {
  month: any ="";
  segmentVal: any = 0;
  typeout: any = null;
  searchDate = null;
  searcholdDate=null;
  dataArrayList: Array<any> = [];
  isSearch:boolean = true;//获取是否有查询条件
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  addobject: any = {};//多选
  isSubmitVipInfo:boolean = true;
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase,
    public base: BaseModal,
    public native: NativeService,
    public alertCtrl:AlertController,
    public modalCtrl:ModalController,
    public menuCtrl:MenuController,
    public actionSheetCtrl:ActionSheetController,
    public popoverCtrl:PopoverController,
    private alertController: AlertController,
    private barcode: BarcodeScanner,
    private platformlocation:PlatformLocation

  ) { super(); 
    this.month = this.com.getNow;
  }
  // ngOnInit() {
  //   this.LoadData(1);
  // }



  EventLink(event,item){
    // console.log(item);
    if(item.qrcode){
      localStorage.setItem("information",JSON.stringify(item));
      this.com.setHistoryUrl();
      this.com.Go(event.url+item.id.value)
      // this.router.navigate([event.url+item.id.value]);
    }

  }
  loadMoreData(event) {
    let that = this;
    if (that.RecordCount == that.dataArrayList.length) {
      if( that.infiniteScroll){
        that.infiniteScroll.disabled = true;
      }
     
    } else {
      that.PageNumber++;
      this.LoadData(that.PageNumber);
    }
  }
  /**
   * 跳转也米娜
   * @param element 
   * @param item 
   */
  EventClick(element,item){
    const that = this;
    that.com.setHistoryUrl(false);
    that.com.Go(element.url+item.id.value + "&" + that.com.getNowDatetime);
    // that.router.navigate([element.url+item.id.value + "&" + that.com.getNowDatetime]);
    console.log(item);
  }
  /**
   * 选择日期
   * @param data 
   */
  Eventdatetime(data){
    console.log(data);
    this.month = data.detail.value;
   this.LoadData(1);
  }
  EventDateTimeClick(){
    let that = this;
    let _obj = {
      value:that.month,
      format:"yyyymmdd"
    };
    that.native.IosselectDateTime(_obj).then(data=>{
      that.month = that.formatDate(data.value);
      that.LoadData(1);
    }).catch(eror=>{
    //console.log(eror);
      });
  }
  LoadData(PageNumber){
    let that = this;

    // console.log("1008611");
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }
    // console.log(that.element);
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let id = that.activaRouter.snapshot.paramMap.get('id');
    if(PageName=="DailyBillInquiryList"){//订单详情
      that.isSearch = false;
    }
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    }else{
      that.msg.Alert("服务端数据配置有误,请联系管理员");
      return;
    }
    // body.ConfigName ="GetSaleServiceList";
    // body.ConfigName="MemberManage";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    if(PageName=="DailyBillInquiryList"){//订单详情
      that.isSearch = false;
      if(id){
        body.RequestBody = JSON.stringify({"orderid":id.split("&")[0]});
      }
    }else{
      let orderDate = that.com.BetweenDate(that.month+" 00:00:00",that.month+" 23:59:59");
      body.RequestBody = JSON.stringify({"a_CreateTime":orderDate,"a_FK_SystemUser_Create_ID":that.com.GetAccount.Id});
    }
   
    that.http.post(app.DEFAULTURL, body).then(data => {
      /****判断是否第一页begin****/
      if(PageNumber == 1){
        that.dataArrayList = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      }else{
        if( that.infiniteScroll){
          that.infiniteScroll.complete();
        }
       
      }
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        console.log(data);
        data.Status.Datas.forEach(function (item) {
          let objfield = {};
          let arrType=[];
          that.element.selectItemList.selectItem.forEach((element, index) => {
            if (element.bindingField) {
              objfield[element.bindingField] = { "value": item[element.field], "text": element.text };
            }
            if((element.bindingField == 'ordercreate') && objfield[element.bindingField].value){
              objfield[element.bindingField].value = objfield[element.bindingField].value.toString().replace(/-/g,"/");
            }
            that.com.CustomerTag(element,objfield,arrType);//获取所有标签
          });
          if(objfield["vipiphone"]){
            if(objfield["vipiphone"].value){
              objfield["vipiphone"].value=that.com.PhoneNum(objfield["vipiphone"].value);
            }
          }
          if(objfield["vipname"]){
            if(objfield["vipname"].value){
              objfield["vipname"].value=that.com.FormatName(objfield["vipname"].value);
            }
          }
          that.dataArrayList.push(objfield);
          // console.log(that.element.selectItemList.selectItem);
          //console.log(that.dataArrayList);
        });
        /****上拉加载数据begin****/
        that.RecordCount = data.Status.RecordCount;
        if(that.RecordCount == data.Status.Datas.length || that.RecordCount == that.dataArrayList.length){
          // that.infiniteScroll.disabled = true;
          if( that.infiniteScroll){
            that.infiniteScroll.disabled = true;
          }
        }else{
          if( that.infiniteScroll){
            that.infiniteScroll.disabled = false;
          }
        }
        /****上拉加载数据end****/
      }else{
        // that.dataArrayList=new Array<any>();
        that.apiObj['status'] = false;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    });
 }
 EventQrCode(item){
   const that=this;
   console.log(item.qrcode.value);
    //#region 判断订单是否当月订单
    if(item.ordercreate.value){
      let riqi:any = item.ordercreate.value;//获取订单日期
      let oDate1 = new Date(riqi.replace("T"," ").replace("Z",'').replace("-00:00",'').replace(/-/g,"/"));//格式化日期针对ios问题
      let year:number=oDate1.getFullYear();//订单年份
      let month:number=oDate1.getMonth()+1;//订单年份
      let _nowdd:number = year+month;//订单年月日
  
      //-------------获取当月的年月--------------------------//
      let now:any = new Date();
      let _nowYear:number= now.getFullYear(); //当前年 
      let _nowMonth:number= now.getMonth()+1; //当前月 
      let _nowym:number = _nowYear+_nowMonth;//当前年月
      if(_nowdd!=_nowym){
        this.msg.Alert("只能绑定当月的订单");
        return;
      }
    }
    //#endregion
         this.com.setHistoryUrl();
        //  let url = item.qrcode.value;
        //  if(item.qrcode.value){
        //    url = item.qrcode.value.replace(/&amp;/g,"&");
        //  }
        //  localStorage.setItem("ordermarstID",item.title.value);
    if(!that.com.GetAccount.Qrcode){
          that.msg.Alert("未提供二维码,请联系管理员");
      }else{
        that.com.setHistoryUrl(false);
        that.com.removeItem(["homing","product","meminfo"]);
        let _imgurl:any = that.com.GetAccount.Qrcode.replace("/placeholder","");
        let _url:any=app.WEBURL+"/"+_imgurl;
        that.com.goQrCode(_url,"qrcode");
      }
      return;
  //  this.router.navigate(["/tabs/qrcode/"+item.qrcode.value]);
 }

 /**
  * 添加会员信息
  */
 addVipInfo(item){
  this.presentAlertInput(item);
 }

 async presentAlertInput(item) {
  const that = this;
  console.log(item,"绑定")
  //#region 判断订单是否当月订单
  if(item.ordercreate.value){
    let riqi:any = item.ordercreate.value;//获取订单日期
    let oDate1 = new Date(riqi.replace("T"," ").replace("Z",'').replace("-00:00",'').replace(/-/g,"/"));//格式化日期针对ios问题
    let year:number=oDate1.getFullYear();//订单年份
    let month:number=oDate1.getMonth()+1;//订单年份
    let _nowdd:number = year+month;//订单年月日

    //-------------获取当月的年月--------------------------//
    let now:any = new Date();
    let _nowYear:number= now.getFullYear(); //当前年 
    let _nowMonth:number= now.getMonth()+1; //当前月 
    let _nowym:number = _nowYear+_nowMonth;//当前年月
    if(_nowdd!=_nowym){
      that.msg.Alert("只能绑定当月的订单");
      return;
    }
  }
  //#endregion
  const alert = await this.alertController.create({
    header: '请输入手机号码',
    mode:"ios",
    inputs: [
      {
        name: 'phone',
        type: 'text',
        label: '请输入手机号码',
        value: '',
        min: 6
      }
    ],
    buttons: [
      {
        text: "取消",
        role: 'cancel',
        cssClass: 'secondary btn-cancel',
        handler: (cancel) => {
          //console.log(cancel,"cancel");
        }
      },
      {
        text: "确认",
        cssClass: 'btn-okay',
        handler: (Okay) => {
          //console.log(Okay,"ok");
          if(!that.isSubmitVipInfo){
            return;
          }
          that.isSubmitVipInfo = false;
          if (Okay && Okay["phone"]) {
            if(!(/^1[23456789]\d{9}$/.test(Okay["phone"]))){ 
              that.msg.Alert("手机号格式不正确").then(()=>{
                that.presentAlertInput(item);
              });
              that.isSubmitVipInfo = true;
            }else{
              let _obj = {};
              _obj["TelPhone"] = Okay["phone"];
              _obj["Order_ID"] = item.title.value || '';
              that.addVipInfoHTTP(_obj);
            }
          } else {
            that.isSubmitVipInfo = true;
            that.msg.Alert("手机号不能为空").then(()=>{
              that.presentAlertInput(item);
            });
          }
        }
      }
     
    ]
  });

  await alert.present();
}

addVipInfoHTTP(obj){
    const that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let id = that.activaRouter.snapshot.paramMap.get('id');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    body.ConfigName = "ProductPurchaseRecordBindMember";
    body.OpType = "edite";
    body.ConfigType = "form";
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    body.RequestBody = JSON.stringify(obj);
    that.msg.Loading("加载中，请稍后...").then(loads=>{
      that.http.post(app.DEFAULTURL, body).then(data => {
        loads.dismiss();
        that.isSubmitVipInfo = true;
        if (data.ResponseMessage.Success) {
          that.msg.Alert("保存成功").then(()=>{
            that.LoadData(1);
          });
        }else{
          that.msg.Alert(data.ResponseMessage.ErrorMessage);
        }
      }).catch(error => {
        loads.dismiss();
        console.log(error);
        that.isSubmitVipInfo = true;
        that.msg.Alert(error.ResponseMessage.ErrorMessage);
      });
      loads.present();
    });
}

// @HostListener('document:ionBackButton', ['$event'])
// private overrideHardwareBackAction($event: any) {
//   const that = this;
//   //  console.log("监听事件...");
//   $event.detail.register(100, async () => {
//     // console.log("返回按钮...");
//     that.androidBackButtonHandle();
//     return;
//   });
// }

/**
 * 返回上一页处理逻辑
 */
async androidBackButtonHandle(){
  const that= this;
  try{
    // that.keyboard.hide();//键盘事件
    const alert = await that.alertCtrl.getTop();
    if(alert){
      alert.dismiss();
      return;
    }
    const action  =await that.actionSheetCtrl.getTop();
    if(action){
      action.dismiss();
      return;
    }
    const popover = await that.popoverCtrl.getTop();
    if(popover){
      popover.dismiss();
      return;
    }
    const modal = await that.modalCtrl.getTop();
    if(modal){
      modal.dismiss();
      return;
    }
    const isOpen = await that.menuCtrl.isOpen();
    if(isOpen){
      that.menuCtrl.close();
      return;
    }
    // console.log("back...");
    that.com.goBack();

  }catch(error){

  }
}
formatDate(date){
  if(date){
    let _date = new Date(date.replace(/-/g,"/"));
    let _y = _date.getFullYear();
    let _m = _date.getMonth()+1;
    let _d = _date.getDate();
    return _y + "-" + (_m < 10?"0"+_m:_m) + "-"+(_d < 10? "0"+_d:_d);
  }else{
    return date;
  }
}

//完善会员标签跳转
hrefClick(item)
{
  this.com.setHistoryUrl(false);
  // debugger;
  let tu = item;
      tu.name=item.vipname;
      tu.phone=item.vipiphone;
      tu.id=item.vipid;
     localStorage.setItem("customerInfo",JSON.stringify(item));
    localStorage.setItem("customerTag",JSON.stringify(tu));
    localStorage.setItem("information",JSON.stringify(tu));
  // this.router.navigateByUrl("/tabs/contact/WCustomerDetail/view/"+item.vipid.value+"&"+this.com.getNowDatetime);
  this.com.Go("/tabs/contact/WCustomerDetail/view/"+item.vipid.value+"&"+this.com.getNowDatetime);
}
}
